// Doc Order — display formatters (port of data.js DO_fmtMoney/Date/Stamp).
// Presentation only — no business rules live here.
import { formatDisplayDate } from './core';

export function fmtMoney(n: number | null | undefined, cents = false): string {
  if ((n === null || n === undefined) || (n as unknown) === '') {
return '—';
}
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: cents ? 2 : 0,
    maximumFractionDigits: cents ? 2 : 0
  }).format(n);
}

export function fmtDate(iso: string | null | undefined): string {
  // R5 #6: THE four-format core contract (YYYY-MM-DD, MM/DD/YYYY, YYYY-MM,
  // ISO timestamps) — the old length-10 T00:00:00 append turned Encompass
  // US-format snapshot dates ("07/13/2026") into Invalid Date → "Received —".
  // Date-only values format from LITERAL components; timestamps render in
  // America/Los_Angeles (PDF parity is test-pinned).
  return formatDisplayDate(iso);
}

/** Audit-trail timestamp: "May 29, 2026 · 3:42 PM". */
export function fmtStamp(iso: string | null | undefined): string {
  if (!iso) {
return '—';
}
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) {
return '—';
}
  const date = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  const time = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  return `${date} · ${time}`;
}
